import type { Router } from 'vue-router';
import type { App } from 'vue';
import type { Pinia } from 'pinia';

import type { PluginOptions } from './type';
import errorPlugin from './error';
import casPlugin from './cas';
import sensorsPlugin from './sensors';
import commonSensorsPlugin from './common-sensors';
import sentryPlugin from './sentry';
import feedbackPlugin from './feedback';
import ratingPlugin from './rating';
import metaPlugin from './meta';
import nprogressPlugin from './nprogress';
import routerPlugin from './router';
import sfDesignPlugin from './sf-design';
import sfVinePlugin from './sf-vine';
import { routerNotInSetup } from '../utils/routerNotInSetup';

const pluginQueue: (PluginOptions[] | PluginOptions)[] = [
  [casPlugin, routerPlugin],
  [errorPlugin, sensorsPlugin, sentryPlugin, feedbackPlugin, ratingPlugin, metaPlugin, nprogressPlugin, sfDesignPlugin, sfVinePlugin],
  commonSensorsPlugin,
];

const pluginsConfig: Required<PluginOptions> = {
  onInit: async (exPlugins = []) => {
    // exPlugins中包含配置初始化插件，因此需要放在最前面执行
    pluginQueue.unshift(...exPlugins);
    for (const plugin of pluginQueue) {
      if (Array.isArray(plugin)) {
        await Promise.all(plugin.map((v) => v.onInit?.()));
        continue;
      }
      await plugin.onInit?.();
    }
  },
  onUserDataUpdate: async (user) => {
    for (const plugin of pluginQueue) {
      if (Array.isArray(plugin)) {
        await Promise.all(plugin.map((v) => v.onUserDataUpdate?.(user)));
        continue;
      }
      await plugin.onUserDataUpdate?.(user);
    }
  },
  onVuePluginRegister: async (options: { router?: Router; app: App<Element>; pinia?: Pinia }) => {
    // 设置全局变量，方便后续在非 setup 中使用
    routerNotInSetup.value = options.router;
    for (const plugin of pluginQueue) {
      if (Array.isArray(plugin)) {
        await Promise.all(plugin.map((v) => v.onVuePluginRegister?.(options)));
        continue;
      }
      await plugin.onVuePluginRegister?.(options);
    }
  },
};

export {
  pluginsConfig,
  casPlugin,
  sensorsPlugin,
  feedbackPlugin,
  ratingPlugin,
  metaPlugin,
  nprogressPlugin,
  sfDesignPlugin,
  sfVinePlugin,
  type PluginOptions,
};
